import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { SwiperModule, SWIPER_CONFIG, SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { AgGridModule } from 'ag-grid-angular';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { HAuthGuard } from '@home/service/auth.guard';

import { SharedModule } from '@app/shared.module';

import { HomeRoutingModule } from '@home/home-routing.module';
import { HomeComponent } from '@home/home.component';

import { MainComponent } from '@home/page/main/main.component';
import { HeaderComponent } from '@home/page/main/header/header.component';
import { FooterComponent } from '@home/page/main/footer/footer.component';
import { SubHeaderComponent } from '@home/page/main/sub-header/sub-header.component';

import { CertificationViewComponent } from '@home/page/modal/certification-view/certification-view.component';

import { BoardComponent } from '@home/page/board/board.component';
import { BoardListComponent } from '@home/page/board/board-list/board-list.component';
import { BoardViewComponent } from '@home/page/board/board-view/board-view.component';
import { BoardWriteComponent } from '@home/page/board/board-write/board-write.component';
import { BoardReplyComponent } from '@home/page/board/board-reply/board-reply.component';

import { LoginComponent } from '@home/page/member/login/login.component';
import { FindIdComponent } from '@home/page/member/find-id/find-id.component';
import { FindPwComponent } from '@home/page/member/find-pw/find-pw.component';
import { MemberJoinComponent } from '@home/page/member/member-join/member-join/member-join.component';
import { MemberJoinCompleteComponent } from '@home/page/member/member-join/member-join-complete/member-join-complete.component';
import { CompanySearchComponent } from '@home/page/member/member-join/company-search/company-search.component';
import { FindIdResultComponent } from '@home/page/member/find-id/find-id-result/find-id-result.component';
import { FindPwResultComponent } from '@home/page/member/find-pw/find-pw-result/find-pw-result.component';
import { MemberEdit1Component } from '@home/page/member/mypage/member-edit/member-edit1/member-edit1.component';
import { MemberWithdrawalComponent } from '@home/page/member/mypage/member-withdrawal/member-withdrawal.component';

import { PaidMemberStep1Component } from '@home/page/member/mypage/paid-member/paid-member-step1/paid-member-step1.component';
import { PaidMemberStep2Component } from '@home/page/member/mypage/paid-member/paid-member-step2/paid-member-step2.component';
import { PaidMemberBankComponent } from '@home/page/member/mypage/paid-member/paid-member-step1/paid-member-bank/paid-member-bank.component';

import { AgGridImageComponent } from '@components/ag-grid-image/ag-grid-image.component';
import { AgGridHtmlComponent } from '@components/ag-grid-html/ag-grid-html.component';
import { AgGridSaveComponent } from '@components/ag-grid-save/ag-grid-save.component';
import { AgGridExcelComponent } from '@components/ag-grid-excel/ag-grid-excel.component';
import { AgGridHeaderCheckboxComponent } from '@components/ag-grid-header-checkbox/ag-grid-header-checkbox.component';

import { ModalMonthComponent } from '@components/modal-month/modal-month.component';
import { ContentsComponent } from '@home/page/contents/contents.component';
import { MypagePaymentComponent } from '@home/page/member/mypage/mypage-payment/mypage-payment.component';
import { MemberDormantComponent } from '@home/page/member/member-dormant/member-dormant.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    HomeComponent,

    // DaumAddressComponent,
    MainComponent,
    HeaderComponent,
    FooterComponent,
    SubHeaderComponent,

    CertificationViewComponent,

    BoardComponent,
    BoardListComponent,
    BoardViewComponent,
    BoardWriteComponent,
    BoardReplyComponent,

    LoginComponent,
    FindIdComponent,
    FindPwComponent,
    MemberJoinComponent,
    MemberJoinCompleteComponent,
    CompanySearchComponent,
    FindIdResultComponent,
    FindPwResultComponent,
    MemberEdit1Component,
    MemberWithdrawalComponent,
    PaidMemberStep1Component,
    PaidMemberStep2Component,
    PaidMemberBankComponent,

    ContentsComponent,

    MypagePaymentComponent,

    MemberDormantComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SwiperModule,
    SharedModule,
    AgGridModule.withComponents([
      AgGridImageComponent,
      AgGridHtmlComponent,
      AgGridHeaderCheckboxComponent
    ]),
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'ko',
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    })
  ],
  providers: [
    HAuthGuard,
    NgbActiveModal,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  entryComponents: [
    CompanySearchComponent,
    PaidMemberBankComponent,
    ModalMonthComponent

  ]
})
export class HomeModule { }
